<div class="modal-header">
  <h4 class="modal-title pull-left">Saving Pipeline</h4>
</div>
<div class="modal-body">
  <div class="mb-1">
    <div>
      @switch (state) {
        @case ('pipeline-process-complete') {
          <div id="complete">
            Pipeline save finished.
          </div>
        }
        @case ('pipeline-process-saving') {
          <div id="saving">
            Your pipeline is being saved.
          </div>
        }
        @default {
          <div id="default">
            Preparing to save your pipeline.
          </div>
        }
      }
    </div>
  </div>
  <div class="progress">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" [style]="widthStyle"></div>
  </div>
</div>
